const StaffRolePrivilegeFeatureType = {
  STAFF_ROLE: 'STAFF_ROLE',
  USER: 'USER',
  BADGE: 'BADGE',
  EVENT: 'EVENT',
  PROJECT: 'PROJECT',
  WALLET: 'WALLET',
};
export default StaffRolePrivilegeFeatureType;

export const staffRolePrivilegeFeatureTypes = [
  StaffRolePrivilegeFeatureType.STAFF_ROLE,
  StaffRolePrivilegeFeatureType.USER,
  StaffRolePrivilegeFeatureType.BADGE,
  StaffRolePrivilegeFeatureType.EVENT,
  StaffRolePrivilegeFeatureType.PROJECT,
  StaffRolePrivilegeFeatureType.WALLET,
];
